import styled from "styled-components";
export const BracketContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 40px;
  align-items: flex-start;
  margin-top: 80px;

  /* On mobile, stack vertically */
  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 10px;
  }
`;


export const RoundColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 220px;

  @media (max-width: 768px) {
    min-width: 100%;
    gap: 10px;
  }
`;
export const MatchupBox = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #333;
  border-radius: 10px;
  padding: 12px;
  background: #fafafa;
  gap: 10px;
`;

export const TeamCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  border: 2px solid transparent;
  background: white;
  transition: 0.2s ease;

  img {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  ${({ selected }) =>
    selected &&
    `
      border-color: #2e7d32;
      background: #d1ffd1;
    `}

  ${({ winner }) =>
    winner &&
    `
      border-color: #2e7d32;
      background: #c8f7c5;
      font-weight: 600;
    `}

  ${({ wrong }) =>
    wrong &&
    `
      border-color: #c62828;
      background: #ffd6d6;
      font-weight: 600;
    `}

  ${({ highlight }) =>
    highlight &&
    `
      border-color: #1565c0;
      background: #dbeaff;
      font-weight: 600;
    `}
`;

export const AdvanceButton = styled.button`
  margin-top: 10px;
  padding: 10px 15px;
  background: #0077cc;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    background: #005fa3;
  }
`;
